import React, { ReactNode } from "react";
import styled from "styled-components";
import { TextAlign, TextColor } from "./helper";

const bodyVariants = [
  "body1",
  "body2",
  "body3",
  "body4",
  "body5",
  "body6",
  "body7",
  "body8",
  "body9",
] as const;

export type BodyVariant = typeof bodyVariants[number];

interface BodyProps {
  variant?: BodyVariant;
  color?: TextColor;
  align?: TextAlign;
}

interface Props extends BodyProps {
  children: ReactNode;
  className?: string;
}

const Body: React.FC<Props> = ({
  color = "primary",
  variant = "body1",
  align = "left",
  className,
  children,
}) => (
  <StyledBody variant={variant} color={color} align={align} className={className}>
    {children}
  </StyledBody>
);

export default Body;

const StyledBody = styled.span<Required<BodyProps>>`
  display: block;
  white-space: pre-line;
  font-family: ${({ theme, variant }) => theme.typography.body[variant].fontFamily};
  font-weight: ${({ theme, variant }) => theme.typography.body[variant].fontWeight};
  font-size: ${({ theme, variant }) => theme.typography.body[variant].fontSize}px;
  color: ${({ theme, color }) => theme.colors.text[color]};
  text-align: ${({ align }) => align};
`;
